import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { IndexedDBService } from '../../services/indexed-db.service';
import { FormsModule } from '@angular/forms';
import { filter } from 'rxjs';


interface MenuItem {
  key: string;
  value: string;
  icon: string;
  color: string;
  route?: boolean | null;
  filter?: string | null;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.html',
  styleUrls: ['./dashboard.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class Dashboard {

  selectedZone: string = 'school';

  constructor(private router: Router) { }

  schoolMenuItems: MenuItem[] = [
    { key: 'booking', value: 'Booking', icon: 'fa fa-calendar', color: '#3b82f6', route: true, filter: 'Booking' },
    { key: 'myList', value: 'School My Teacher', icon: 'fa fa-th-list', color: '#f59e0b', route: true, filter: 'SchoolMyTeacher' },
    { key: 'school', value: 'School Profile', icon: 'fa fa-address-book', color: '#8bb12cff', route: true, filter: 'School' },
    // { key: 'preConfirmedBooking', value: 'Pre-Confirmed Booking', icon: 'fa fa-check-circle', color: '#10b981', route: false, filter: 'Pre-Confirmed Booking' },
    { key: 'teacherinvites', value: 'FNT / Teacher Invites', icon: 'fa fa-envelope', color: '#ef4444', route: true, filter: 'InviteTeacher' },
    { key: 'smartGroup', value: 'Smart Group', icon: 'fa fa-users', color: '#6366f1', route: true, filter: 'SmartGroup' },
    { key: 'schoolUser', value: 'School User', icon: 'fa fa-users', color: '#ff25e6ff', route: true, filter: 'SchoolAdditionalUser' },
    { key: 'findNew', value: 'Find New', icon: 'fa fa-search', color: '#0ea5e9', route: false, filter: 'Find New' },
    { key: 'requests', value: 'Requests', icon: 'fa fa-bell', color: '#8b5cf6', route: false, filter: 'Requests' },
    { key: 'jobs', value: 'Jobs', icon: 'fa fa-briefcase', color: '#ec4899', route: false, filter: 'Jobs' }
  ];

  teacherMenuItems: MenuItem[] = [
    { key: 'profile', value: 'Profile', icon: 'fa fa-user', color: '#3b82f6', route: true, filter: 'Teacher' },
    { key: 'schoolInvites', value: 'School Invites', icon: 'fa fa-envelope', color: '#aa63f1', route: true, filter: 'InviteSchool' },
  ];

  async setRouter(item: MenuItem) {
    await IndexedDBService.save('logsFilters', {
      action: 'create',
      model: item.filter || '',
      date: '',
      user: ''
    });

    if (item.route) {
      this.router.navigate(['logs']); // ✅ currently navigates always to 'logs'
    }
  }

 async onZoneChange(event: any) {
  const selected = event.target.value;
  this.selectedZone = selected;

  if (selected === 'loginLogout') {
    await IndexedDBService.save('logsFilters', {
      action: 'loginlogout',
      model: 'Booking',
      date: '',
      user: ''
    });

    this.router.navigate(['logs']);
  }
}

  // You can add additional logic here based on the selected value
}
